import React from 'react'

import * as styles from './LoadingOverlay.m.css'

type Props = {
  children: React.ReactNode | React.ReactNode[]
}

const LoadingOverlay: React.FC<Props> = (props: Props): React.ReactElement => {
  const { children } = props
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.loadingSpinner}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {children}
      </div>
    </div>
  )
}

export default LoadingOverlay
